





























import { Vue, Component, Prop } from 'vue-property-decorator';
import OrderingInterface from '@core/interfaces/ordering-interface';
import { SelectOptionInterface } from '@shared/interfaces/inputs';

@Component
export default class TableOrdering extends Vue {
  @Prop({ type: Object, required: true }) value!: OrderingInterface;
  @Prop({ type: Array, required: true }) readonly orderByOptions!: SelectOptionInterface[];
  @Prop({ type: Function, required: true }) readonly clickOnChangeOrderDirection!: (
    direction: string,
  ) => void;

  // COMPUTED
  get model(): OrderingInterface {
    return this.value;
  }

  set model(value: OrderingInterface) {
    this.$emit('input', value);
  }
}
